<template>
  <b-row>
    <b-col class="col-1 pointer-cursor" v-if="locked">
      <font-awesome-icon icon="lock" size="2x" color="red"/>
    </b-col>
    <b-col class="col-1 pointer-cursor" v-else>
      <img
        v-if="record['items'][0].institution_logo && record['items'][0].institution_logo!=='None'"
        :src="`data:image/png;base64,${record.institution_logo}`"
        class="institutionLogo"
      />
      <font-awesome-icon v-else icon="plaid-icon" size="2x"/>
    </b-col>
    <b-col class="ml-2">
      <span class="h4 pointer-cursor">
        {{ record['items'][0].institution_name || record['items'][0].institution_id }}
      </span>
      <p
        v-if="record['items'][0].accounts.length"
        class="pointer-cursor text-secondary"
      >
        {{ record['items'][0].accounts.length }} accounts...
      </p>
      <p
        v-else
        class="pointer-cursor text-secondary"
        @click="updatePendingReport"
      >
        Processing Asset Report...
      </p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ItemCard',
  props: {
    record: {
      required: true,
    },
    locked: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    updatePendingReport() {
      this.$reqs.post(`/users/${this.user.id}/plaid/asset_report`, {
        asset_report_id: this.record.asset_report_id,
        save_to_contacts: true,
      }).then(() => {
        this.$swal({
          title: 'Report ready. Please refresh page.',
          text: 'Your Asset Report is ready. Please refresh this page!',
          type: 'info',
          confirmButtonText: 'Ok',
        }).then(() => {
          this.$emit('reload');
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/plaid/ItemCard.vue